import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from 'react-router-dom';
import TransactionSuccessIcon from "../../assets/testRide/transactionSuccessIcon.svg";

import "../pocUniqueCustomer/PosUniqueCode.scss";

import { getCookie , setCookie} from "src/utils/utils";

const LoanSuccess = () => {
  const [loader, setLoader] = useState(false);

  const history = useHistory();
  const { search } = useLocation();




  let userOrdersDetails = localStorage.getItem("loanOrderDetails");

  let orderDetails = JSON.parse(userOrdersDetails);

  
  return (
    <>
      <div className="pos-code-main-container">
        <div className="right-container">
          <div className="vertical-center-payment">
            <div className="pos-code-container payment-containrt">
              <div className="form-container flex">
                <div className="form-controls">
                  <div>
                    <img
                      className="transctions_img"
                      src={TransactionSuccessIcon}
                      alt="TransactionsSucess"
                    />
                  </div>
                  <div
                    className="payment transaction_lable"
                    style={{ position: "relative", top: 10 }}
                  >
                    <div className="label">Loan initiated successfully</div>
                    <div className="transations_sub_lable">
                      <div>
                        Order ID: {orderDetails?.order_id}
                      </div>
                    </div>
                  </div>
                  <div>
                    <button
                      className={"submit_btn"}
                      type="submit"
                       onClick={() => history.push("/offline-finance-search")}
                      style={{ bottom: "2%" }}
                    >
                      Done
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoanSuccess;
